export const SidebarIdContent = 'CONTENT' as const;
